class UserDetailsFormController {
  constructor ($scope, $rootScope, I18n) {
    'ngInject'
    this.I18n = I18n
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.isProcessing = false
  }

  toggleForm () {
    if (!this.editMode) {
      this.editMode = true
    }
  }

  submitForm () {
    this.isProcessing = true
    this.success = null
    this.error = null
    const details = this.form.$$controls.reduce((acc, $field) => {
      acc[$field.$name] = this.form[$field.$name].$modelValue
      return acc
    }, {})

    this.onSubmit({details})
      .then(() => {
        this.isProcessing = false
        this.success = 'my-profile.my-details.success'
        this.editMode = false
        this.safeApply()
        return Promise.resolve()
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-profile.my-details.error',
          cause: err
        }
        this.safeApply()
        return Promise.reject(err)
      })
  }

  cancelForm () {
    this.editMode = !this.editMode
    this.onCancel()
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }
}

export default UserDetailsFormController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/user-details-form/user-details-form.controller.js